//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

module.exports = {
    name: 'offer-page',
    props: [
        'payload',
        'globalData'
    ],
    methods: {
        skip: function() {
            this.$emit('skipStep');
        },
        submit: function() {
            this.$emit('submitStep');
        }
    }
}
